import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { Router } from "@lit-labs/router";

import { routes, fallbackRoute } from "./router";
import { setRootRouter } from "./lib/navigation";

/**
 * Application root. Owns the single page-level Router (which installs the
 * global click/popstate listeners) and renders the matched page into the
 * light DOM so the global theme stylesheet applies without a shadow boundary.
 */
@customElement("app-root")
export class AppRoot extends LitElement {
  private router: Router;

  constructor() {
    super();
    this.router = new Router(this, routes, { fallback: fallbackRoute });
    setRootRouter(this.router);
  }

  protected createRenderRoot(): this {
    return this;
  }

  render() {
    return this.router.outlet();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "app-root": AppRoot;
  }
}
